function initMobileHover() {
  document.querySelectorAll('.card-wrapper').forEach(wrapper => {
    if (wrapper.dataset.touchInit) return;
    wrapper.dataset.touchInit = 'true';

    let holdTimer;

    wrapper.addEventListener('touchstart', () => {
      holdTimer = setTimeout(() => {
        wrapper.classList.add('is-touched');
      }, 150);
    }, { passive: true });

    wrapper.addEventListener('touchend', () => {
      clearTimeout(holdTimer);
      wrapper.classList.remove('is-touched');
    }, { passive: true });

    wrapper.addEventListener('touchcancel', () => {
      clearTimeout(holdTimer);
      wrapper.classList.remove('is-touched');
    }, { passive: true });
  });
}

initMobileHover();

const observer = new MutationObserver(initMobileHover);
observer.observe(document.body, { childList: true, subtree: true });